import { isInteger } from 'formik'

export function cutBreadcrumbActiveItem(){
  let item =     document.querySelector('.breadcrumb-item.active');
  let itemContent = item.innerHTML.replace(/<[^>]*>?/gm, '');
  let savedContentInLS = localStorage.getItem('breadcrumb-active-item'+window.location.pathname);
  let contentContainer = document.querySelector('#content-container')
  let contentContainerWidth = contentContainer ? contentContainer.clientWidth :0 ;
  if(!savedContentInLS ||  !savedContentInLS.includes(itemContent.slice(0,10))){
    localStorage.setItem('breadcrumb-active-item'+window.location.pathname, itemContent);
  }

  if(window.innerWidth < 1024){
    if(itemContent){
      let shortVersion = item.innerHTML.replace(/<[^>]*>?/gm, '').slice(0,10)+'...';
      item.innerHTML = shortVersion;
    }
  }else{
    if(savedContentInLS) {
      item.innerHTML = savedContentInLS;
    }
  }

  if(contentContainer) {

    for(let i =0; getBreadCrumbsItemsTotalWitdh() > contentContainerWidth && contentContainerWidth >0; i++) {
      if (itemContent) {
        let shortVersion = item.innerHTML.replace(/<[^>]*>?/gm, '').slice(0, item.innerHTML.length / 2) + '...';
        item.innerHTML = shortVersion;
        //Jesli nadal za dlugi tniemy 2 raz
        if (getBreadCrumbsItemsTotalWitdh() > contentContainerWidth) {
          let shortVersion = item.innerHTML.replace(/<[^>]*>?/gm, '').slice(0, item.innerHTML.length / 2) + '...';
          item.innerHTML = shortVersion;
        }
      }
    }
  }



}
function getBreadCrumbsItemsTotalWitdh(){
let breadcrumb = document.querySelector("#main > nav > ul");
let breadcrumbItems = breadcrumb.childNodes;
let totalWidth = 0;

breadcrumbItems.forEach((item)=>{
  if(Number.isInteger(item.clientWidth)){
    totalWidth+=item.clientWidth;
  }

})
return totalWidth;
}